import { createAction } from 'redux-actions';
import Log from 'forms-utils-lib/logger/Logger';
import { getInventory } from 'FormsUI/api/Inventory';
export const REQUEST_FETCH_INVENTORY = 'REQUEST_FETCH_INVENTORY';
export const SUCCEED_FETCH_INVENTORY = 'SUCCEED_FETCH_INVENTORY';
export const FAIL_FETCH_IVENTORY = 'FAIL_FETCH_IVENTORY';
export const requestFetchInventory = createAction(REQUEST_FETCH_INVENTORY);
export const succeedFetchInventory = createAction(SUCCEED_FETCH_INVENTORY);
export const failFetchInventory = createAction(FAIL_FETCH_IVENTORY);
export const fetchInventory = () => dispatch => {
  dispatch(requestFetchInventory());
  return getInventory().then(({
    products
  }) => {
    dispatch(succeedFetchInventory({
      ownedProducts: products.filter(product => !product.bundle),
      bundles: products.filter(product => product.bundle)
    }));
  }).catch(error => {
    Log.error('Error Fetching Products Inventory', {
      error
    });
    dispatch(failFetchInventory());
  });
};